import { Form } from './../../classes/Form'

export default {
    namespaced: true,

    state: {
        modal: false,
        form: new Form({
            name: '',
            email: '',
            city: '',
            message: '',
            productRate: 0,
            serviceRate: 0,
            deliveryRate: 0,
            token: ''
        }),
    },

    getters: {

    },

    mutations: {
        setFormValue (state, { key, value }) {
            state.form[key] = value;
        },

        showModal (state) {
            state.modal = true;
        },

        hideModal (state) {
            state.modal = false;
        }
    },

    actions: {
        submit ({ commit, state }) {
            return new Promise((resolve, reject) => {
                state.form.post('/feedback')
                    .then(response => {
                        console.log('success');
                        /*commit('setItemsCount', response.data.itemsCount);

                        commit('setItemQuantity', {
                            index: index,
                            quantity: response.data.quantity
                        });*/

                        resolve(response.data);
                    })
                    .catch(error => {
                        console.log('error');

                        reject(error);
                    });
            });
        }
    }
}
